import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  IconButton,
  Button,
  MenuItem,
  Menu,
  Stack,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import React, { useState } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import CircularProgress from "@mui/material/CircularProgress";
import AddRoleMasterModel from "./AddRoleMasterModel";
import EditRoleMasterModel from "./EditRoleMasterModel";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import {
  deleteRoleMastersList,
  updateRoleMastersList,
} from "../../../redux/actions/mastersAction";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import noData from "../../../assets/images/Group 688.png";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const RoleMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state?.user?.isLoading);

  const roleMasterData = useSelector((state) => state?.masters?.roleMasterData);

  const [RoleRowData, setRoleRowData] = useState("");

  const [isAddRoleMasterModel, setIsAddRoleMasterModel] = useState(false);
  const [isEditRoleMasterModel, setIsEditRoleMasterModel] = useState(false);
  const [isPaginationLimit, setIsPaginationLimit] = useState("");

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };
  const handleCloseAddRoleMasterModel = (e) => {
    setIsAddRoleMasterModel(false);
  };

  const handleCloseEditRoleMasterModel = (e) => {
    setIsEditRoleMasterModel(false);
  };

  const handleDeleteRole = (Roleid) => {
    dispatch(
      deleteRoleMastersList({
        id: Roleid,
      })
    );
  };

  const toggleActiveStatus = (Rolerow) => {
    dispatch(
      updateRoleMastersList({
        id: Rolerow?.id,
        active: !Rolerow?.active,
      })
    );
  };

  const onExportHandler = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportFormShape = roleMasterData.map((user) => {
      return {
        "Role Name": user?.name,
        "Last Modified By And Date": moment(user?.updatedAt).format(
          "D MMMM, YYYY | hh:mm A"
        ),
      };
    });
    const ws = XLSX.utils.json_to_sheet(exportFormShape);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Role Master" + fileExtension);
  };

  return (
    <>
      {isAddRoleMasterModel && (
        <AddRoleMasterModel
          isAddRoleMasterModel={isAddRoleMasterModel}
          handleCloseAddRoleMasterModel={handleCloseAddRoleMasterModel}
        />
      )}
      {isEditRoleMasterModel && (
        <EditRoleMasterModel
          isEditRoleMasterModel={isEditRoleMasterModel}
          handleCloseEditRoleMasterModel={handleCloseEditRoleMasterModel}
          RoleRowData={RoleRowData}
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Role Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "10px", mr: 2 }}
            >
              {/* <Button
                variant="outlined"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  borderColor: "#26875C",
                  width: "6rem",
                  backgroundColor: "FFFFFF",
                  padding: "6px 0px 4px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  ":hover": {
                    borderColor: "#26875C",
                  },
                }}
                onClick={() => setIsAddRoleMasterModel(true)}
              >
                <Box sx={{ marginRight: "10px" }}>
                  <img src={ActiveAddButton} alt="" />
                </Box>
                Add
              </Button> */}
              <Button
                variant="contained"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "6rem",
                  backgroundColor: "#26875C",
                  padding: "7px 0px 5px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                // onClick={() => setIsAddChecklistModel(true)}
                onClick={() => (isLoading ? null : onExportHandler())}
              >
                Export
              </Button>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {roleMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {/* <TableCell sx={{ color: "#B5B5C3", fontWeight: 600 }}>
                    Role Id
                  </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Role Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Active
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Last Modified By And Date
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell> */}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {roleMasterData.map((row, index) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                        {row?.id}
                      </TableCell> */}
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          <Box onClick={() => toggleActiveStatus(row)}>
                            <AntSwitch checked={row?.active} color="primary" />
                          </Box>
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.updatedAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            display: "flex",
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              setRoleRowData(row);
                              setIsEditRoleMasterModel(true);
                            }}
                          >
                            <img src={EditButton} width="30" height="30" />
                          </IconButton>

                          <IconButton onClick={() => handleDeleteRole(row?.id)}>
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton>
                        </TableCell> */}
                        <TableCell></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          {/* <Divider />
          {roleMasterData.length > 0 && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="">10</MenuItem>
                  <MenuItem value={10}>20</MenuItem>
                  <MenuItem value={20}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={10}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )} */}
        </Box>
      </Paper>
    </>
  );
};

export default RoleMasterContent;
